import _ from 'lodash'

export const checkIsInterestIncomplete = data => {
  const values = [
    'company.baseCountry',
    'company.name',
    'company.website',
    'contactPerson.telephone'
  ].map(name => _.get(data, name))
  return values.some(v => v === '<not specified>')
}

export default {
  checkIsInterestIncomplete
}
